import React, { ComponentType } from 'react';

const customGlobalStyles = `
  body, td, th, input, select, textarea, button, [class^="k-"]:not(.k-icon) {
    font-family: 'Open Sans', sans-serif;
    font-size: 13px;
  }
`;

function ApplyTheme<P>(Component: ComponentType<P>): ComponentType<P> {
  return (props: P) => (
    <>
      <style>{customGlobalStyles}</style>
      <Component {...props} />
    </>
  );
}
export default ApplyTheme;
